import { Box, Card, CardContent } from "@mui/material";

import { ActionButton } from "components/ActionButton";
import { CardGrid } from "components/CardGrid";
import { FrmFieldGrid } from "components/FrmFieldGrid";
import { FrmSelectFromObjects } from "components/formFields/FrmSelectFromObjects";
import { CardHeader } from "components/formFields/formCards/CardHeader";
import { FrmCheckbox } from "components/formFields/frm";

import { i18n } from "services/i18nService";
import {
  SHIPPING_TYPE_OPTIONS,
  RATE_OPTIONS,
  CONFIRMATION_OPTIONS,
} from "services/sosInventoryService/upsShipment/schema";

export function ShippingOptions(props) {
  const { record, onChange, onScalarChange, openRatesDialog, isInError } =
    props;

  return (
    <Card variant="outlined">
      <CardContent>
        <Box
          display="flex"
          sx={{ mb: 1, alignItems: "start", justifyContent: "space-between" }}
        >
          <CardHeader text={i18n("frmLabel.ShippingOptions")} />
          <ActionButton
            headerButton
            size="medium"
            onClick={openRatesDialog}
            sx={{ mt: "0.3em" }}
          >
            {i18n("upsShipment.CompareTimeAndCost")}
          </ActionButton>
        </Box>
        <CardGrid>
          <FrmFieldGrid gridAutoFlow="dense">
            <FrmSelectFromObjects
              name="serviceCode"
              label={i18n("frmLabel.Service")}
              value={record.serviceCode ? { id: record.serviceCode } : null}
              onValueChange={onScalarChange}
              options={SHIPPING_TYPE_OPTIONS}
              error={isInError("serviceCode")}
              disableClearable
            />
            <FrmSelectFromObjects
              name="rateType"
              label={i18n("frmLabel.Rate")}
              value={record.rateType ? { id: record.rateType } : null}
              onValueChange={onScalarChange}
              options={RATE_OPTIONS}
              disableClearable
              error={isInError("rateType")}
            />
            <FrmSelectFromObjects
              name="deliveryConfirmationCode"
              label={i18n("frmLabel.DeliveryConfirmation")}
              value={
                record.deliveryConfirmationCode
                  ? { id: record.deliveryConfirmationCode }
                  : null
              }
              onValueChange={onScalarChange}
              options={CONFIRMATION_OPTIONS}
              error={isInError("deliveryConfirmationCode")}
              disableClearable
            />
            <FrmCheckbox
              name="saturdayDelivery"
              label={i18n("frmLabel.DeliverOnSaturday")}
              onValueChange={onChange}
              value={record.saturdayDelivery}
            />
            <FrmCheckbox
              name="additionalHandling"
              label={i18n("frmLabel.AdditionalHandling")}
              onValueChange={onChange}
              value={record.additionalHandling}
            />
          </FrmFieldGrid>
        </CardGrid>
      </CardContent>
    </Card>
  );
}
